import { useAttribution as u } from "./attribution.js";
import { useLeafletContext as m } from "./context.js";
import { useEventHandlers as a } from "./events.js";
import { withPane as c } from "./pane.js";
function H(n, o) {
  return function(t, i) {
    const e = m(), r = n(c(t, e), e);
    return u(e.map, t.attribution), a(r.current, t.eventHandlers), o(r.current, e, t, i), r;
  };
}
export {
  H as createDivOverlayHook
};
